@if (title(); as title) {
  <div class="overlay__header">
    <span>{{ title | translate }}</span>
  </div>
}
<div class="overlay__list">
  @for (item of items(); track item[dataKey()]) {
    <ng-container [ngTemplateOutlet]="menuItemContent()" [ngTemplateOutletContext]="{ item, index: $index }"></ng-container>
  } @empty {
    @if (emptyMessageContent()) {
      <ng-container [ngTemplateOutlet]="emptyMessageContent()!"></ng-container>
    }
    @if (emptyMessage()) {
      <span>{{ emptyMessage() }}</span>
    }
  }
</div>
